import styled from 'styled-components'

interface FullHeightWrapperProps {
  children: React.ReactNode
  style?: React.CSSProperties
  className?: string
}

export const FullHeightWrapper: React.FC<FullHeightWrapperProps> = ({
  children,
  style,
  className,
}) => {
  return (
    <StyledFullHeightWrapper style={style} className={className}>
      {children}
    </StyledFullHeightWrapper>
  )
}

const StyledFullHeightWrapper = styled.div`
  overflow: hidden;
  font-size: 14px;
  background-color: #fff;
  display: flex;
  justify-content: flex-start;
`
